import Swal from 'sweetalert2';

export const AI_EDIT_RESULT_ERRORS = {
  CONTENT_MODERATED: 'content_moderated',
  MISSING_IMAGE: 'missing_image_url',
};

/**
 * Tells why an /ai-edit status response cannot be applied to the canvas.
 * The API flags results blocked by the provider safety filter with
 * `moderated: true` instead of returning the provider's black placeholder.
 * @param {Object} [data] - Body of the completed /ai-edit status request
 * @returns {string|null} One of AI_EDIT_RESULT_ERRORS, or null when usable
 */
export function getAiEditResultError(data) {
  if (data?.moderated) {
    return AI_EDIT_RESULT_ERRORS.CONTENT_MODERATED;
  }
  if (!data?.imageUrl) {
    return AI_EDIT_RESULT_ERRORS.MISSING_IMAGE;
  }
  return null;
}

export const showModeratedResultMessage = (featureName) =>
  Swal.fire({
    icon: 'warning',
    title: 'Foto non elaborata',
    text: `La funzione «${featureName}» non è riuscita a elaborare questa foto. La foto non è stata modificata e non è stato scalato alcun credito. Riprova con un'altra foto; se il problema continua, contatta l'assistenza.`,
    confirmButtonColor: '#278e8e',
  });
